export default __webpack_public_path__ + "static/media/Python.20251ca3.svg";